import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const LandingPageFeatures = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14918)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#FFEDBF"
          />
          <path
            d="M175.954 41.8522V114.831C175.954 117.251 174.993 119.571 173.282 121.282C171.571 122.993 169.251 123.954 166.831 123.954H80.1687C77.7493 123.954 75.4289 122.993 73.7182 121.282C72.0074 119.571 71.0463 117.251 71.0463 114.831V41.8522H175.954Z"
            fill="#66E1FF"
          />
          <path
            d="M71.0463 41.8522V114.831C71.0463 117.251 72.0074 119.571 73.7182 121.282C75.4289 122.993 77.7493 123.954 80.1687 123.954H84.7299L166.831 41.8522H71.0463Z"
            fill="#C2F3FF"
          />
          <path
            d="M175.954 41.8523H71.0463V28.1687C71.0463 25.7493 72.0074 23.4289 73.7182 21.7182C75.4289 20.0074 77.7493 19.0463 80.1687 19.0463H166.831C169.251 19.0463 171.571 20.0074 173.282 21.7182C174.993 23.4289 175.954 25.7493 175.954 28.1687V41.8523Z"
            fill="white"
          />
          <path
            d="M166.831 19.0463H80.1687C77.7493 19.0463 75.4289 20.0074 73.7182 21.7182C72.0074 23.4289 71.0463 25.7493 71.0463 28.1687V114.831C71.0463 117.251 72.0074 119.571 73.7182 121.282C75.4289 122.993 77.7493 123.954 80.1687 123.954H166.831C169.251 123.954 171.571 122.993 173.282 121.282C174.993 119.571 175.954 117.251 175.954 114.831V28.1687C175.954 25.7493 174.993 23.4289 173.282 21.7182C171.571 20.0074 169.251 19.0463 166.831 19.0463Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M71.0463 41.8522H175.954"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M87.0104 31.5896C86.708 31.5896 86.418 31.4694 86.2041 31.2556C85.9903 31.0417 85.8701 30.7517 85.8701 30.4493C85.8701 30.1468 85.9903 29.8568 86.2041 29.6429C86.418 29.4291 86.708 29.309 87.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M87.0104 31.5896C87.3128 31.5896 87.6028 31.4694 87.8167 31.2556C88.0305 31.0417 88.1507 30.7517 88.1507 30.4493C88.1507 30.1468 88.0305 29.8568 87.8167 29.6429C87.6028 29.4291 87.3128 29.309 87.0104 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M100.694 31.5896C100.392 31.5896 100.102 31.4694 99.8877 31.2556C99.6739 31.0417 99.5537 30.7517 99.5537 30.4493C99.5537 30.1468 99.6739 29.8568 99.8877 29.6429C100.102 29.4291 100.392 29.309 100.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M100.694 31.5896C100.996 31.5896 101.286 31.4694 101.5 31.2556C101.714 31.0417 101.834 30.7517 101.834 30.4493C101.834 30.1468 101.714 29.8568 101.5 29.6429C101.286 29.4291 100.996 29.309 100.694 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M114.378 31.5896C114.075 31.5896 113.785 31.4694 113.571 31.2556C113.357 31.0417 113.237 30.7517 113.237 30.4493C113.237 30.1468 113.357 29.8568 113.571 29.6429C113.785 29.4291 114.075 29.309 114.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <path
            d="M114.378 31.5896C114.68 31.5896 114.97 31.4694 115.184 31.2556C115.398 31.0417 115.518 30.7517 115.518 30.4493C115.518 30.1468 115.398 29.8568 115.184 29.6429C114.97 29.4291 114.68 29.309 114.378 29.309"
            stroke="#191919"
            strokeWidth="1.5"
          />
          <circle
            cx="91"
            cy="57"
            r="3.25"
            stroke="black"
            strokeWidth="1.5"
          />
          <path
            d="M103.202 53.5991H151.348"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.202 60.4009H141.408"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="91"
            cy="73"
            r="3.25"
            stroke="black"
            strokeWidth="1.5"
          />
          <path
            d="M103.202 73H141.408"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="91"
            cy="89"
            r="3.25"
            stroke="black"
            strokeWidth="1.5"
          />
          <path
            d="M103.202 85.5991H151.348"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.202 92.4009H141.408"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="91"
            cy="105"
            r="3.25"
            stroke="black"
            strokeWidth="1.5"
          />
          <path
            d="M103.202 105H151.348"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14918">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
